import { Injectable } from '@angular/core'
import { ConfigService } from '../services/config.service'
import {
   HttpRequest,
   HttpHandler,
   HttpEvent,
   HttpInterceptor,
} from '@angular/common/http'
import { Observable } from 'rxjs'

@Injectable()
export class CommonApiParamsInterceptor implements HttpInterceptor {

   get apiParams() {
      return this.config.apiParams
   }
   get apiUrl() {
      return this.config.apiUrl
   }

   constructor(private config: ConfigService) { }

   intercept(
      request: HttpRequest<unknown>,
      next: HttpHandler
   ): Observable<HttpEvent<unknown>> {
      if (this.apiParams && request.url.indexOf(this.apiUrl ?? '') > -1) {
         request = request.clone({
            setParams: {...this.apiParams, product: this.config.product },
         })}
      return next.handle(request)
   }
}
